import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PencilSimple, Check, Smiley, Clock, XIcon, ArrowCounterClockwise } from "@phosphor-icons/react";
import { CircleCheckbox } from "./CircleCheckbox";
import { TodoItem as TodoItemType } from "@/types";
import { useRef, useEffect } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { EmojiPicker, EmojiPickerContent, EmojiPickerFooter, EmojiPickerSearch } from "@/components/ui/emoji-picker";
import { TimePicker, formatTimeDisplay } from "./TimePicker";
export interface TodoItemProps {
  todo: TodoItemType;
  isEditing: boolean;
  editText: string;
  editEmoji: string;
  editTime: string;
  isMobile: boolean;
  onToggle: (id: string) => void;
  onDelete: (id: string) => void;
  onUnarchive?: (id: string) => void;
  onEdit: (id: string, text: string, emoji?: string) => void;
  setEditText: (text: string) => void;
  setEditEmoji: (emoji: string) => void;
  setEditTime: (time: string) => void;
  handleEditTodo: (todo: TodoItemType) => void;
  cancelEditing: () => void;
}
export function TodoItem(t0) {
  const $ = _c(37);
  const {
    todo,
    isEditing,
    editText,
    editEmoji,
    editTime,
    isMobile,
    onToggle,
    onDelete,
    onUnarchive,
    onEdit,
    setEditText,
    setEditEmoji,
    setEditTime,
    handleEditTodo,
    cancelEditing
  } = t0;
  const editInputRef = useRef(null);
  let t1;
  if ($[0] !== setEditText) {
    t1 = e => {
      const input = e.target;
      const newValue = input.value;
      const newPosition = input.selectionStart;
      setEditText(newValue);
      requestAnimationFrame(() => {
        if (input && newPosition !== null) {
          input.setSelectionRange(newPosition, newPosition);
        }
      });
    };
    $[0] = setEditText;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleEditInputChange = t1;
  let t2;
  if ($[2] !== onDelete || $[3] !== todo.id) {
    t2 = e_0 => {
      e_0.stopPropagation();
      onDelete(todo.id);
    };
    $[2] = onDelete;
    $[3] = todo.id;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleDelete = t2;
  let t3;
  if ($[5] !== onUnarchive || $[6] !== todo.id) {
    t3 = e_1 => {
      e_1.stopPropagation();
      if (onUnarchive) {
        onUnarchive(todo.id);
      }
    };
    $[5] = onUnarchive;
    $[6] = todo.id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleUnarchive = t3;
  const t4 = todo.todo_item_status === "done" ? "text-muted-foreground/50" : "hover:bg-muted/50";
  const t5 = isEditing && "bg-muted/80 rounded-lg";
  const t6 = !isEditing && "cursor-pointer";
  let t7;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = cn("group flex items-start px-4 py-2.5 gap-3", t4, t5, t6, "transition-colors");
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== isEditing || $[13] !== onToggle || $[14] !== todo.id) {
    t8 = e_2 => {
      if (!isEditing && e_2.target === e_2.currentTarget) {
        onToggle(todo.id);
      }
    };
    $[12] = isEditing;
    $[13] = onToggle;
    $[14] = todo.id;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== cancelEditing || $[17] !== editEmoji || $[18] !== editText || $[19] !== editTime || $[20] !== handleDelete || $[21] !== handleEditInputChange || $[22] !== handleEditTodo || $[23] !== handleUnarchive || $[24] !== isEditing || $[25] !== isMobile || $[26] !== onEdit || $[27] !== onToggle || $[28] !== onUnarchive || $[29] !== setEditEmoji || $[30] !== setEditTime || $[31] !== todo) {
    t9 = isEditing ? <><div className="flex-1 flex items-center gap-2 py-0.5"><div className="flex items-center gap-2 rounded-lg bg-background p-1 flex-1 border shadow-sm"><Popover><PopoverTrigger asChild={true}><Button variant="ghost" size="icon" className="h-8 w-8 shrink-0 rounded-md hover:bg-muted">{editEmoji ? <span className="text-base">{editEmoji}</span> : <Smiley className="w-4 h-4 text-muted-foreground" weight="fill" />}</Button></PopoverTrigger><PopoverContent className="w-[280px] p-0 rounded-xl" side="top" align="start" sideOffset={12}><div className="flex h-[300px] w-full items-center justify-center p-0"><EmojiPicker onEmojiSelect={emoji => {
                  setEditEmoji(emoji.emoji);
                }} className="h-full"><EmojiPickerSearch placeholder="Search emoji..." /><EmojiPickerContent className="h-[220px]" /><EmojiPickerFooter className="border-t-0 p-1.5" /></EmojiPicker></div></PopoverContent></Popover><Input ref={editInputRef} value={editText} onChange={handleEditInputChange} onKeyDown={e_3 => {
            if (e_3.key === "Enter") {
              handleEditTodo({
                ...todo,
                text: editText,
                emoji: editEmoji,
                time: editTime
              });
            } else {
              if (e_3.key === "Escape") {
                cancelEditing();
              }
            }
          }} autoFocus={true} className="flex-1 h-8 py-0 text-sm bg-transparent border-0 shadow-none focus-visible:ring-0 px-2 rounded-none" placeholder="Edit todo..." /><TimePicker time={editTime} onChange={setEditTime} /></div><div className="flex gap-1"><Button variant="ghost" size="icon" className="h-8 w-8 shrink-0 text-muted-foreground hover:text-destructive rounded-md hover:bg-muted" onClick={e_4 => {
            e_4.stopPropagation();
            cancelEditing();
          }}><XIcon className="w-4 h-4" weight="bold" /></Button><Button variant="secondary" size="icon" className="h-8 w-8 shrink-0 rounded-md" onClick={e_5 => {
            e_5.stopPropagation();
            const updatedTodo = {
              ...todo,
              text: editText,
              emoji: editEmoji,
              time: editTime
            };
            handleEditTodo(updatedTodo);
          }}><Check className="w-4 h-4" weight="bold" /></Button></div></div></> : <><div onClick={_temp} className="mt-0.5"><CircleCheckbox checked={todo.todo_item_status === "done"} onCheckedChange={() => onToggle(todo.id)} className={cn(todo.todo_item_status === "done" ? "border-muted-foreground/50 bg-muted-foreground/20" : "hover:border-muted-foreground/70")} /></div><div className="flex-1 flex items-start min-w-0 cursor-pointer" onClick={e_7 => {
        e_7.stopPropagation();
        onToggle(todo.id);
      }}>{todo.emoji && <span className="mr-2 text-base flex-shrink-0 mt-0.5">{todo.emoji}</span>}<div className="flex flex-col min-w-0"><span className={cn(todo.text.length > 50 ? "text-xs leading-relaxed" : todo.text.length > 30 ? "text-sm leading-relaxed" : "text-[15px] leading-relaxed", todo.todo_item_status === "done" && "line-through")}>{todo.text}</span>{todo.time && <div className="flex items-center gap-1 text-xs text-muted-foreground mt-0.5"><Clock className="w-3 h-3" weight="fill" /><span>{formatTimeDisplay(todo.time)}</span></div>}</div></div><Button variant="ghost" size="icon" className={cn("h-7 w-7 text-muted-foreground hover:text-foreground", isMobile ? "opacity-100" : "opacity-0 group-hover:opacity-100 transition-opacity")} onClick={e_8 => {
        e_8.stopPropagation();
        onEdit(todo.id, todo.text, todo.emoji);
      }}><PencilSimple className="w-4 h-4" weight="bold" /></Button>{onUnarchive && todo.removed && <Button variant="ghost" size="icon" className={cn("h-7 w-7 text-muted-foreground hover:text-primary", isMobile ? "opacity-100" : "opacity-0 group-hover:opacity-100 transition-opacity")} onClick={handleUnarchive} title="Unarchive"><ArrowCounterClockwise className="w-4 h-4" weight="bold" /></Button>}<Button variant="ghost" size="icon" className={cn("h-7 w-7 text-muted-foreground hover:text-destructive", isMobile ? "opacity-100" : "opacity-0 group-hover:opacity-100 transition-opacity")} onClick={handleDelete}><XIcon className="w-4 h-4" weight="bold" /></Button></>;
    $[16] = cancelEditing;
    $[17] = editEmoji;
    $[18] = editText;
    $[19] = editTime;
    $[20] = handleDelete;
    $[21] = handleEditInputChange;
    $[22] = handleEditTodo;
    $[23] = handleUnarchive;
    $[24] = isEditing;
    $[25] = isMobile;
    $[26] = onEdit;
    $[27] = onToggle;
    $[28] = onUnarchive;
    $[29] = setEditEmoji;
    $[30] = setEditTime;
    $[31] = todo;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== t7 || $[34] !== t8 || $[35] !== t9) {
    t10 = <div className={t7} onClick={t8}>{t9}</div>;
    $[33] = t7;
    $[34] = t8;
    $[35] = t9;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  return t10;
}
function _temp(e_6) {
  return e_6.stopPropagation();
}